import styled from 'styled-components/macro';
import {
  space,
  layout,
  flexbox,
  SpaceProps,
  LayoutProps,
  FlexboxProps,
} from 'styled-system';

export type SegmentedButtonProps = SpaceProps &
  LayoutProps &
  FlexboxProps & {
    selected?: boolean;
  };

const buttonShadow = '0 4px 6px rgba(50, 50, 93, 0.15), 0 1px 3px rgba(0, 0, 0, 0.1)';

export const SegmentedButton = styled.button<SegmentedButtonProps>`
  font-family: ${(props) =>
    props.selected ? props.theme.fontSegmentedButton : props.theme.fontText};
  font-size: 1.4rem;
  line-height: 33px;
  color: ${(props) => props.theme.textColor};
  background-color: ${(props) => (props.selected ? props.theme.highLightColor : '#fff')};
  border: none;
  border-radius: 4px;
  height: 33px;
  min-width: 75px;
  padding: 0 12px;
  box-shadow: ${(props) => (props.theme.shadows ? buttonShadow : 'none')};
  cursor: pointer;
  transition: all 0.2s;
  ${space}
  ${layout}
  ${flexbox}

  :hover {
    transform: translateY(-1px);
    background-color: ${(props) => props.theme.highLightColor};
  }

  :active {
    transform: translateY(1px);
  }

  &.focus-visible {
    outline: none;
    box-shadow: ${buttonShadow}, 0px 0px 0px 2px ${(props) => props.theme.textColor};
  }
  @media screen and (max-width: 767px) {
    min-width: 50px;
  }
`;
